/* MakNorte v2 — comportamentos da home e da PDP. Vanilla, sem dependências.
   Dados reais: /search/suggest.json, /cart/add.js, /cart.js. Nenhum desconto é calculado aqui além do que o tema exibe (settings). */
(function () {
  'use strict';
  const CFG = Object.assign({ whatsapp: '5585997826491', pixPercent: 0, maxInstallments: 12, minInstallmentCents: 3000, cartUrl: '/cart', storefrontApiVersion: '2026-04', shippingQuoteTimeoutMs: 5000, cartSyncTimeoutMs: 5000, scalaReadyTimeoutMs: 2500 }, window.MNV2 || {});
  const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  const money = (cents) => BRL.format((Number(cents) || 0) / 100);
  const qs = (sel, root) => (root || document).querySelector(sel);
  const qsa = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const reducedMotion = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  const scrollBehavior = () => reducedMotion && reducedMotion.matches ? 'auto' : 'smooth';
  const CEP_KEY = 'maknorte_cep';
  const CEP_SAVED_AT_KEY = 'maknorte_cep_saved_at';
  const CEP_RETENTION_MS = 30 * 864e5;
  const PRODUCER_ID = 'maknorte-theme-v2';
  const PRODUCER_SCHEMA_VERSION = 1;
  const GLOBAL_PIXEL_EVENTS = new Set([
    'mn_search_suggest',
    'mn_shipping_quote',
    'mn_whatsapp_click',
  ]);
  const GLOBAL_PIXEL_FIELDS = {
    mn_search_suggest: ['results', 'query_length'],
    mn_shipping_quote: ['uf', 'options', 'cheapest'],
    mn_whatsapp_click: ['where', 'page_type'],
  };
  let preferencesState = 'unknown';
  let preferencesReady = false;
  let sessionCep = '';

  function browserStorage() {
    try { return localStorage; } catch (e) { return null; }
  }

  function clearPersistedCep() {
    const storage = browserStorage();
    try { if (storage) { storage.removeItem(CEP_KEY); storage.removeItem(CEP_SAVED_AT_KEY); } } catch (e) { /* noop */ }
    try { document.cookie = `${CEP_KEY}=;path=/;max-age=0;SameSite=Lax;Secure`; } catch (e) { /* noop */ }
  }

  function refreshPreferences(confirmed) {
    const previous = preferencesState;
    if (confirmed) preferencesReady = true;
    if (!preferencesReady) {
      preferencesState = 'unknown';
      return preferencesState;
    }
    let next = 'unknown';
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.preferencesProcessingAllowed === 'function') {
        const allowed = privacy.preferencesProcessingAllowed();
        if (allowed === true) next = 'allowed';
        else if (allowed === false) next = 'denied';
      }
    } catch (e) { next = 'unknown'; }
    preferencesState = next;
    if (next === 'denied' && previous !== 'denied') {
      clearPersistedCep();
      if (previous === 'allowed') sessionCep = '';
    } else if (next === 'allowed' && previous !== 'allowed') {
      try { document.cookie = `${CEP_KEY}=;path=/;max-age=0;SameSite=Lax;Secure`; } catch (e) { /* noop */ }
    }
    return preferencesState;
  }

  function initPreferences() {
    document.addEventListener('visitorConsentCollected', () => refreshPreferences(true));
    try {
      const shopify = window.Shopify;
      if (!shopify || typeof shopify.loadFeatures !== 'function') return;
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) { preferencesReady = false; preferencesState = 'unknown'; return; }
        refreshPreferences(true);
      });
    } catch (e) { preferencesReady = false; preferencesState = 'unknown'; }
  }

  initPreferences();

  function publish(name, payload) {
    const eventId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    try {
      if (GLOBAL_PIXEL_EVENTS.has(name) && window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        const safePayload = {};
        const fields = GLOBAL_PIXEL_FIELDS[name] || [];
        fields.forEach((field) => {
          if (payload && Object.prototype.hasOwnProperty.call(payload, field)) safePayload[field] = payload[field];
        });
        window.Shopify.analytics.publish(name, Object.assign(safePayload, { event_id: eventId, emitter_id: PRODUCER_ID, schema_version: PRODUCER_SCHEMA_VERSION }));
      }
    } catch (e) { /* noop */ }
    try { document.dispatchEvent(new CustomEvent('mv2:track', { detail: { name, payload: payload || {}, eventId, emitter_id: PRODUCER_ID, schema_version: PRODUCER_SCHEMA_VERSION } })); } catch (e) { /* noop */ }
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message, linkText, linkHref) {
    const el = qs('[data-mv2-toast]');
    if (!el) return;
    el.textContent = message;
    if (linkText && linkHref) { const a = document.createElement('a'); a.href = linkHref; a.textContent = linkText; el.appendChild(a); }
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------- Carrinho (Ajax API nativa) ---------- */
  let cartEventModulePromise;
  function cartEventModule() {
    if (!cartEventModulePromise) {
      const pending = import('@shopify/events').catch(() => {
        if (cartEventModulePromise === pending) cartEventModulePromise = undefined;
        throw new Error('Não foi possível iniciar a atualização do carrinho. Tente novamente.');
      });
      cartEventModulePromise = pending;
    }
    return cartEventModulePromise;
  }

  function cartSectionIds() {
    return Array.from(new Set(qsa('cart-items-component').map((item) => item.dataset && item.dataset.sectionId).filter(Boolean)));
  }

  async function fetchAbsoluteCart() {
    const controller = new AbortController();
    const configuredTimeout = Number(CFG.cartSyncTimeoutMs);
    const timeoutMs = Number.isFinite(configuredTimeout) && configuredTimeout > 0 ? configuredTimeout : 5000;
    let timeoutId;
    const deadline = new Promise((resolve, reject) => {
      timeoutId = setTimeout(() => {
        controller.abort();
        reject(new Error('Cart refresh timed out'));
      }, timeoutMs);
    });
    try {
      const request = (async () => {
        const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw new Error('Cart refresh failed');
        const cart = await response.json();
        if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0 || !Array.isArray(cart.items)) throw new Error('Cart refresh was invalid');
        return cart;
      })();
      return await Promise.race([request, deadline]);
    } finally {
      clearTimeout(timeoutId);
    }
  }

  async function requestCartAdd(payload) {
    const controller = new AbortController();
    const configured = Number(CFG.cartAddTimeoutMs);
    const timeoutMs = Number.isFinite(configured) && configured > 0 ? configured : 8000;
    let timer;
    const deadline = new Promise((_resolve, reject) => {
      timer = setTimeout(() => {
        controller.abort();
        reject(new Error('cart_add_timeout'));
      }, timeoutMs);
    });
    try {
      const request = (async () => {
        const response = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', signal: controller.signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        let data = null;
        try { data = await response.json(); } catch (error) { if (response.ok) throw error; }
        if (response.ok && (!data || typeof data !== 'object')) throw new Error('cart_add_body_invalid');
        return { response, data };
      })();
      return await Promise.race([request, deadline]);
    } catch (error) {
      // O servidor pode ter recebido a linha: confirmar no carrinho, sem repetir POST.
      throw Object.assign(new Error('Não foi possível confirmar a adição. Confira o carrinho antes de continuar.'), { cartMutationUncertain: true });
    } finally { clearTimeout(timer); }
  }

  async function performCartAdd(items, source) {
    const { CartErrorEvent, CartLinesUpdateEvent } = await cartEventModule();
    const sectionIds = cartSectionIds();
    const payload = { items };
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    let res, data;
    try {
      const result = await requestCartAdd(payload);
      res = result.response;
      data = result.data;
    } catch (error) {
      document.dispatchEvent(new CartErrorEvent({ error: error.message, code: 'INVALID' }));
      throw error;
    }
    if (!res.ok) {
      const msg = data && (data.description || data.message) || 'Não foi possível adicionar. Tente novamente.';
      document.dispatchEvent(new CartErrorEvent({ error: msg, code: 'INVALID', detail: { description: data && data.description, errors: data && data.errors } }));
      throw Object.assign(new Error(msg), { cartMutationUncertain: res.status >= 500 });
    }
    publish('mn_add_to_cart', { source: source || 'theme', items: items.map((i) => ({ id: i.id, quantity: i.quantity })) });

    let ajaxCart = null;
    try {
      ajaxCart = await fetchAbsoluteCart();
      refreshCartCount(ajaxCart);
    } catch (e) { /* A adição já ocorreu; não repetir nem apresentá-la como falha. */ }

    if (ajaxCart) {
      const result = {
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          items: Array.isArray(ajaxCart.items) ? ajaxCart.items : [],
          source: 'mn-v2',
          sourceId: source || 'theme',
          sections: data.sections,
          didError: false,
        },
      };
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'standard-action',
        lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
        promise: Promise.resolve(result),
        detail: { source: source || 'theme' },
      }));
    }
    if (!ajaxCart && source !== 'buy_now') {
      window.location.href = CFG.cartUrl;
    }
    document.dispatchEvent(new CustomEvent('mv2:cart:updated'));
    return data;
  }

  let cartAddQueue = Promise.resolve();
  function cartAdd(items, source) {
    const operation = cartAddQueue.then(() => performCartAdd(items, source));
    cartAddQueue = operation.catch(() => undefined);
    return operation;
  }
  async function refreshCartCount(currentCart) {
    const targets = qsa('[data-mv2-cart-count]');
    if (!targets.length) return;
    try {
      const cart = currentCart || await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());
      targets.forEach((t) => { t.textContent = String(cart.item_count); t.hidden = cart.item_count === 0; });
    } catch (e) { /* noop */ }
  }

  /* ---------- Sugestões da busca (Shopify predictive search API) ---------- */
  function prioritizeExactTitleModel(products, query) {
    const normalizedQuery = String(query || '').trim().toUpperCase();
    const modelParts = normalizedQuery.match(/[A-Z]+|\d+/g) || [];
    if (modelParts.length < 2 || !/[A-Z]/.test(normalizedQuery) || !/\d/.test(normalizedQuery)) return products;
    if (modelParts.join('') !== normalizedQuery.replace(/[^A-Z0-9]/g, '')) return products;
    const modelPattern = new RegExp(`(^|[^A-Z0-9])${modelParts.join('[\\s._/-]*')}(?=$|[^A-Z0-9])`, 'i');
    const exact = []; const native = [];
    products.forEach((product) => (modelPattern.test(String(product.title || '')) ? exact : native).push(product));
    return exact.length ? exact.concat(native) : products;
  }

  function initSearch() {
    qsa('[data-mv2-search]').forEach((wrap) => {
      const input = qs('input[type="search"]', wrap);
      const list = qs('[data-mv2-suggest]', wrap);
      if (!input || !list) return;
      let timer; let controller; let requestGeneration = 0; let activeIndex = -1; let renderedOptions = [];
      const clearActive = () => {
        activeIndex = -1;
        if (typeof input.removeAttribute === 'function') input.removeAttribute('aria-activedescendant');
        else input.setAttribute('aria-activedescendant', '');
        renderedOptions.forEach((option) => option.setAttribute('aria-selected', 'false'));
      };
      const cancelPending = () => {
        requestGeneration += 1;
        clearTimeout(timer); timer = null;
        if (controller) controller.abort();
        controller = null;
      };
      const close = (cancel = true) => {
        if (cancel) cancelPending();
        clearActive(); list.hidden = true; list.innerHTML = ''; renderedOptions = []; input.setAttribute('aria-expanded', 'false');
      };
      const setActive = (index) => {
        if (!renderedOptions.length) { clearActive(); return; }
        activeIndex = (index + renderedOptions.length) % renderedOptions.length;
        renderedOptions.forEach((option, i) => option.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'));
        input.setAttribute('aria-activedescendant', renderedOptions[activeIndex].id);
        if (typeof renderedOptions[activeIndex].scrollIntoView === 'function') renderedOptions[activeIndex].scrollIntoView({ block: 'nearest' });
      };
      const render = (products, q) => {
        clearActive(); list.innerHTML = ''; renderedOptions = [];
        if (!products.length) {
          const li = document.createElement('li'); li.className = 'mv2-suggest__empty'; li.textContent = `Nenhum produto para “${q}”. Pressione Enter para buscar na loja inteira.`; list.appendChild(li);
        }
        products.forEach((p, index) => {
          const li = document.createElement('li'); li.setAttribute('role', 'presentation');
          const a = document.createElement('a'); a.id = `${list.id || 'MnSuggest'}-option-${index}`; a.className = 'mv2-suggest__item'; a.href = p.url; a.tabIndex = -1; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
          const img = document.createElement('img'); img.className = 'mv2-suggest__img'; img.alt = ''; img.loading = 'lazy';
          if (p.featured_image && p.featured_image.url) img.src = p.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x120$1$2');
          const text = document.createElement('span'); text.className = 'mv2-suggest__text';
          const title = document.createElement('span'); title.className = 'mv2-suggest__title'; title.textContent = p.title;
          const meta = document.createElement('span'); meta.className = 'mv2-suggest__meta'; meta.textContent = [p.vendor, p.product_type].filter(Boolean).join(' · ');
          text.append(title, meta);
          const price = document.createElement('span'); price.className = 'mv2-suggest__price';
          if (p.price) price.textContent = BRL.format(parseFloat(p.price));
          a.append(img, text, price); li.appendChild(a); list.appendChild(li); renderedOptions.push(a);
        });
        list.hidden = false; input.setAttribute('aria-expanded', 'true');
      };
      input.addEventListener('input', () => {
        const q = input.value.trim();
        cancelPending();
        close(false);
        if (q.length < 2) return;
        const generation = requestGeneration;
        timer = setTimeout(async () => {
          timer = null;
          const requestController = new AbortController();
          controller = requestController;
          try {
            const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag`;
            const data = await fetch(url, { signal: requestController.signal, headers: { Accept: 'application/json' } }).then((r) => r.json());
            if (generation !== requestGeneration || input.value.trim() !== q) return;
            const nativeProducts = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            const products = prioritizeExactTitleModel(nativeProducts, q);
            render(products, q);
            publish('mn_search_suggest', { results: products.length, query_length: Math.min(q.length, 100) });
          } catch (e) { if (e.name !== 'AbortError' && generation === requestGeneration) close(false); }
          finally { if (controller === requestController) controller = null; }
        }, 180);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const hadSuggestions = !list.hidden || Boolean(timer) || Boolean(controller);
          close();
          if (hadSuggestions) e.preventDefault();
          return;
        }
        if (list.hidden || !renderedOptions.length) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex < 0 ? renderedOptions.length - 1 : activeIndex - 1); }
        else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
        else if (e.key === 'End') { e.preventDefault(); setActive(renderedOptions.length - 1); }
        else if (e.key === 'Enter' && activeIndex >= 0) {
          e.preventDefault(); renderedOptions[activeIndex].click();
        }
      });
      document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) close(); });
      qsa('[data-mv2-chip]', wrap.closest('section') || document).forEach((chip) => {
        chip.addEventListener('click', () => { input.value = chip.dataset.mv2Chip || chip.textContent.trim(); input.focus(); input.dispatchEvent(new Event('input')); });
      });
    });
  }

  /* ---------- Kit por tipo de negócio ---------- */
  function initKits() {
    const root = qs('[data-mv2-kit]');
    if (!root) return;
    const tabs = qsa('[role="tab"]', root);
    const panels = qsa('[data-mv2-kit-panel]', root);
    const summaryName = qs('[data-mv2-kit-name]', root);
    const summaryCount = qs('[data-mv2-kit-count]', root);
    const total = qs('[data-mv2-kit-total]', root);
    const pix = qs('[data-mv2-kit-pix]', root);
    const parcel = qs('[data-mv2-kit-parcel]', root);
    const addBtn = qs('[data-mv2-kit-add]', root);
    const waLink = qs('[data-mv2-kit-wa]', root);
    let active = 0;
    function selected(panel) { return qsa('[data-mv2-kit-item]', panel).filter((it) => it.dataset.available === 'true' && qs('[data-mv2-check]', it).getAttribute('aria-pressed') === 'true'); }
    function recalc() {
      const panel = panels[active]; if (!panel) return;
      const items = selected(panel);
      const cents = items.reduce((sum, it) => sum + Number(it.dataset.price || 0), 0);
      if (summaryName) summaryName.textContent = tabs[active] ? tabs[active].textContent.trim() : '';
      if (summaryCount) summaryCount.textContent = String(items.length);
      if (total) total.textContent = money(cents);
      if (pix) { const row = pix.closest('[data-mv2-kit-pix-row]'); if (CFG.pixPercent > 0 && cents > 0) { pix.textContent = money(Math.round(cents * (100 - CFG.pixPercent) / 100)); if (row) row.hidden = false; } else if (row) row.hidden = true; }
      if (parcel) { const row = parcel.closest('[data-mv2-kit-parcel-row]'); const n = Math.min(CFG.maxInstallments, Math.floor(cents / Math.max(1, CFG.minInstallmentCents))); if (n >= 2) { parcel.textContent = `${n}x sem juros de ${money(Math.ceil(cents / n))}`; if (row) row.hidden = false; } else if (row) row.hidden = true; }
      if (addBtn) addBtn.disabled = items.length === 0;
      if (waLink) {
        const names = items.map((it) => it.dataset.title).join('; ');
        const kitLabel = tabs[active] ? tabs[active].textContent.trim() : 'kit';
        waLink.href = `https://wa.me/${CFG.whatsapp}?text=${encodeURIComponent(`Olá! Quero cotar o kit ${kitLabel}: ${names}`)}`;
      }
    }
    function select(i, focusTab, shouldTrack) {
      active = i;
      tabs.forEach((t, k) => { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach((p, k) => { p.hidden = k !== i; });
      if (focusTab && tabs[i]) tabs[i].focus();
      recalc();
      if (shouldTrack) publish('mn_kit_tab', { kit: tabs[i] ? tabs[i].textContent.trim() : String(i) });
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i, false, true));
      t.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true, true); if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true, true); });
    });
    qsa('[data-mv2-check]', root).forEach((chk) => {
      chk.addEventListener('click', () => {
        const item = chk.closest('[data-mv2-kit-item]');
        const on = chk.getAttribute('aria-pressed') !== 'true';
        chk.setAttribute('aria-pressed', on ? 'true' : 'false');
        item.classList.toggle('mv2-kit__item--off', !on);
        recalc();
      });
    });
    if (addBtn) addBtn.addEventListener('click', async () => {
      const items = selected(panels[active]).map((it) => ({ id: Number(it.dataset.variant), quantity: 1 }));
      if (!items.length) { toast('Selecione ao menos um item do kit.'); return; }
      addBtn.disabled = true;
      try { await cartAdd(items, 'kit'); toast(`${items.length} itens adicionados ao carrinho.`, 'Ver carrinho', CFG.cartUrl); publish('mn_kit_add', { kit: tabs[active].textContent.trim(), count: items.length }); }
      catch (e) { toast(e.message); }
      finally { addBtn.disabled = false; }
    });
    root.addEventListener('mv2:kit:select', (e) => { const i = Number(e.detail); if (!Number.isNaN(i) && tabs[i]) select(i, false, false); });
    select(0);
    qsa('[data-mv2-goto-kit]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const idx = Number(btn.dataset.mv2GotoKit);
        if (!Number.isNaN(idx) && tabs[idx]) { e.preventDefault(); select(idx, false, true); }
        // scrollIntoView: no desktop o tema rola dentro de .page-wrapper, não na janela.
        root.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
        // Seções acima com content-visibility mudam de altura ao renderizar; realinha uma vez.
        setTimeout(() => { if (Math.abs(root.getBoundingClientRect().top - 90) > 40) root.scrollIntoView({ block: 'start' }); }, 900);
        if (!Number.isNaN(idx) && tabs[idx]) setTimeout(() => tabs[idx].focus({ preventScroll: true }), 400);
      });
    });
  }

  /* ---------- Catálogo: filtros, ordenação, comparação ---------- */
  const compare = [];
  function cardData(card) {
    return { id: card.dataset.variant, handle: card.dataset.handle, title: card.dataset.title, brand: card.dataset.brand, volt: card.dataset.volt, price: Number(card.dataset.price || 0), img: card.dataset.img, url: card.dataset.url, available: card.dataset.available === 'true', directAdd: card.dataset.directAdd === 'true' };
  }
  function renderTray() {
    const tray = qs('[data-mv2-tray]'); if (!tray) return;
    const list = qs('[data-mv2-tray-list]', tray); const count = qs('[data-mv2-tray-count]', tray);
    list.innerHTML = '';
    compare.forEach((d) => {
      const li = document.createElement('li'); li.className = 'mv2-tray__item';
      const img = document.createElement('span'); img.className = 'mv2-tray__img'; if (d.img) { const i = document.createElement('img'); i.src = d.img; i.alt = ''; img.appendChild(i); }
      const text = document.createElement('span'); text.className = 'mv2-tray__text';
      const t = document.createElement('a'); t.className = 'mv2-tray__title'; t.href = d.url; t.textContent = d.title;
      const m = document.createElement('span'); m.className = 'mv2-tray__meta'; m.textContent = [d.brand, d.volt].filter(Boolean).join(' · ');
      const p = document.createElement('span'); p.className = 'mv2-tray__price'; p.textContent = d.available ? money(d.price) : 'Indisponível';
      text.append(t, m, p);
      const needsOptions = d.available && !d.directAdd;
      const btn = document.createElement(needsOptions ? 'a' : 'button'); btn.className = 'mv2-tray__add';
      if (needsOptions) { btn.href = d.url; btn.textContent = 'Ver opções'; }
      else {
        btn.type = 'button'; btn.textContent = 'Adicionar'; btn.disabled = !d.available;
        btn.addEventListener('click', async () => { btn.disabled = true; try { await cartAdd([{ id: Number(d.id), quantity: 1 }], 'compare'); toast('Adicionado ao carrinho.', 'Ver carrinho', CFG.cartUrl); } catch (e) { toast(e.message); } finally { btn.disabled = !d.available; } });
      }
      li.append(img, text, btn); list.appendChild(li);
    });
    if (count) count.textContent = `${compare.length} de 3`;
    tray.hidden = compare.length === 0;
  }
  function toggleCompare(card) {
    const d = cardData(card); const btn = qs('[data-mv2-compare]', card);
    const idx = compare.findIndex((c) => c.handle === d.handle);
    if (idx >= 0) { compare.splice(idx, 1); btn.setAttribute('aria-pressed', 'false'); card.classList.remove('mv2-card--compared'); }
    else {
      if (compare.length >= 3) { toast('Você pode comparar até 3 produtos. Remova um para adicionar outro.'); return; }
      compare.push(d); btn.setAttribute('aria-pressed', 'true'); card.classList.add('mv2-card--compared');
      publish('mn_compare_add', { handle: d.handle });
    }
    renderTray();
  }
  function initCards() {
    qsa('[data-mv2-card]').forEach((card) => {
      const cmp = qs('[data-mv2-compare]', card);
      if (cmp) cmp.addEventListener('click', () => toggleCompare(card));
      const cart = qs('[data-mv2-card-add]', card);
      if (cart) cart.addEventListener('click', async () => {
        const d = cardData(card);
        if (!d.available || !d.id || !d.directAdd) { window.location.href = d.url; return; }
        cart.disabled = true;
        try { await cartAdd([{ id: Number(d.id), quantity: 1 }], 'card'); toast('Adicionado ao carrinho.', 'Ver carrinho', CFG.cartUrl); }
        catch (e) { toast(e.message); }
        finally { cart.disabled = false; }
      });
    });
    const tray = qs('[data-mv2-tray]');
    if (tray) { const close = qs('[data-mv2-tray-close]', tray); if (close) close.addEventListener('click', () => { compare.splice(0, compare.length); qsa('[data-mv2-compare][aria-pressed="true"]').forEach((b) => { b.setAttribute('aria-pressed', 'false'); b.closest('[data-mv2-card]').classList.remove('mv2-card--compared'); }); renderTray(); }); }
  }
  function initCatalog() {
    const root = qs('[data-mv2-catalog]'); if (!root) return;
    const grid = qs('[data-mv2-grid]', root); const cards = qsa('[data-mv2-card]', grid);
    const brandSel = qs('[data-mv2-brand]', root); const sortSel = qs('[data-mv2-sort]', root); const voltBtns = qsa('[data-mv2-volt]', root);
    const count = qs('[data-mv2-count]', root); const empty = qs('[data-mv2-empty]', root);
    const state = { brand: '', volt: '', sort: 'rel' };
    cards.forEach((c, i) => { c.dataset.order = String(i); });
    function apply() {
      let visible = 0;
      cards.forEach((c) => {
        const d = cardData(c);
        const ok = (!state.brand || d.brand === state.brand) && (!state.volt || d.volt === state.volt);
        c.hidden = !ok; if (ok) visible += 1;
      });
      const sorted = cards.slice().sort((a, b) => {
        if (state.sort === 'asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (state.sort === 'desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      sorted.forEach((c) => grid.appendChild(c));
      if (count) count.textContent = `${visible} ${visible === 1 ? 'produto' : 'produtos'}`;
      if (empty) empty.hidden = visible > 0;
      publish('mn_catalog_filter', state);
    }
    if (brandSel) brandSel.addEventListener('change', () => { state.brand = brandSel.value; apply(); });
    if (sortSel) sortSel.addEventListener('change', () => { state.sort = sortSel.value; apply(); });
    voltBtns.forEach((b) => b.addEventListener('click', () => { state.volt = b.dataset.mv2Volt; voltBtns.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false')); apply(); }));
    const clear = qs('[data-mv2-clear]', root);
    if (clear) clear.addEventListener('click', () => { state.brand = ''; state.volt = ''; if (brandSel) brandSel.value = ''; voltBtns.forEach((x) => x.setAttribute('aria-pressed', x.dataset.mv2Volt === '' ? 'true' : 'false')); apply(); });
  }

  /* ---------- Navegação inferior / FAB ---------- */
  function initNav() {
    const nav = qs('[data-mv2-bottomnav]'); if (!nav) return;
    const path = window.location.pathname;
    qsa('a[href]', nav).forEach((a) => { const href = a.getAttribute('href'); if ((href === '/' && path === '/') || (href !== '/' && href.split('#')[0] && path.startsWith(href.split('#')[0]) && href.split('#')[0] !== '/')) a.setAttribute('aria-current', 'page'); });
    const search = qs('[data-mv2-nav-search]', nav);
    if (search) search.addEventListener('click', (e) => {
      const input = qs('[data-mv2-search] input[type="search"]');
      if (input) { e.preventDefault(); input.scrollIntoView({ behavior: scrollBehavior(), block: 'center' }); setTimeout(() => input.focus({ preventScroll: true }), 350); }
    });
    refreshCartCount();
    const pageTypes = { index: 'home', product: 'product', collection: 'collection', search: 'search', cart: 'cart', page: 'page', blog: 'blog', article: 'blog', policy: 'policy' };
    const templateType = Object.keys(pageTypes).find((type) => document.body.classList.contains(`template-${type}`));
    const pageType = pageTypes[templateType] || 'other';
    qsa('[data-mv2-wa]').forEach((a) => a.addEventListener('click', () => publish('mn_whatsapp_click', { where: a.dataset.mv2Wa || 'theme', page_type: pageType })));
  }

  /* ---------- PDP ---------- */
  function productForm() {
    return qs('product-information form[action*="/cart/add"], .product-details form[action*="/cart/add"]')
      || qs('product-form-component form[action*="/cart/add"], form[action*="/cart/add"][id^="product-form"], form[action*="/cart/add"]');
  }
  function currentVariantId() {
    const form = productForm();
    if (!form) return null;
    const input = qs('input[name="id"]', form);
    const selector = qs('quantity-selector-component[data-variant-id]', form);
    const raw = String(input?.value || selector?.dataset?.variantId || '').trim();
    return /^\d+$/.test(raw) && Number(raw) > 0 ? Number(raw) : null;
  }
  function currentQty() { const f = productForm(); const q = f ? qs('input[name="quantity"]', f) : null; const n = q ? parseInt(q.value, 10) : 1; return Number.isFinite(n) && n > 0 ? n : 1; }
  let buyingNow = false;
  function scalaCheckoutButton() {
    const hosts = qsa('scala-cart-button');
    for (const host of hosts) {
      const button = host.shadowRoot && host.shadowRoot.querySelector('#scala-button');
      if (button && !button.disabled) return button;
    }
    return null;
  }
  /* ---------- Comprar agora: o cliente escolhe Pix ou cartão antes de ir ao pagamento ---------- */
  function visibleText(sel) {
    const el = qs(sel);
    if (!el || el.closest('[hidden]')) return '';
    return el.textContent.replace(/\s+/g, ' ').trim();
  }
  async function otherCartUnits(id) {
    try {
      const cart = await fetchAbsoluteCart();
      return cart.items.filter((i) => Number(i.variant_id) !== Number(id)).reduce((n, i) => n + (Number(i.quantity) || 0), 0);
    } catch (e) { return 0; }
  }
  function ensurePayStyles() {
    if (qs('#mv2-pay-css')) return;
    const st = document.createElement('style');
    st.id = 'mv2-pay-css';
    st.textContent = '.mv2-pay{border:0;border-radius:14px;padding:0;width:min(420px,calc(100vw - 32px));max-height:calc(100dvh - 32px);color:#111827;box-shadow:0 18px 50px rgba(0,0,0,.25)}'
      + '.mv2-pay::backdrop{background:rgba(17,24,39,.55)}'
      + '.mv2-pay form{display:grid;gap:12px;margin:0;padding:20px 18px 18px;position:relative}'
      + '.mv2-pay h2{margin:0 36px 2px 0;font-size:18px;line-height:1.3}'
      + '.mv2-pay__opt{display:grid;gap:2px;width:100%;text-align:left;padding:14px 16px;border:2px solid #c9d0da;border-radius:12px;background:#fff;color:#111827;font:inherit;cursor:pointer;min-height:44px}'
      + '.mv2-pay__opt:hover,.mv2-pay__opt:focus-visible{border-color:#0b3d91;outline:none}'
      + '.mv2-pay__opt--pix{border-color:#087443;background:#edf8f1}'
      + '.mv2-pay__opt strong{font-size:16px}.mv2-pay__opt span{font-size:15px;font-weight:700}.mv2-pay__opt small{font-size:13px;color:#374151}'
      + '.mv2-pay__aviso{margin:0;padding:10px 12px;border-radius:10px;background:#fff7e6;color:#7a4b00;font-size:13px;line-height:1.45}'
      + '.mv2-pay__link{display:inline;padding:0;border:0;background:none;color:#0b3d91;font:inherit;font-weight:700;text-decoration:underline;cursor:pointer}'
      + '.mv2-pay__x{position:absolute;top:10px;right:10px;width:36px;height:36px;border:0;border-radius:50%;background:#f3f4f6;color:#111827;font-size:20px;line-height:1;cursor:pointer}';
    document.head.appendChild(st);
  }
  function payOption(value, title, line, note, extraClass) {
    const b = document.createElement('button');
    b.type = 'submit'; b.value = value; b.className = 'mv2-pay__opt' + (extraClass ? ` ${extraClass}` : '');
    const t = document.createElement('strong'); t.textContent = title; b.appendChild(t);
    if (line) { const l = document.createElement('span'); l.textContent = line; b.appendChild(l); }
    if (note) { const n = document.createElement('small'); n.textContent = note; b.appendChild(n); }
    return b;
  }
  function choosePayment(quantity, others) {
    return new Promise((resolve) => {
      if (typeof HTMLDialogElement !== 'function') { resolve('cart'); return; }
      ensurePayStyles();
      const each = quantity > 1 ? ' cada' : '';
      const pix = visibleText('[data-mn-pix-row] [data-mn-pix-price]');
      const card = visibleText('[data-mn-product-price]');
      const parcel = visibleText('[data-mn-installments] [data-mn-installment-price]');
      const dlg = document.createElement('dialog');
      dlg.className = 'mv2 mv2-pay';
      dlg.setAttribute('aria-labelledby', 'mv2-pay-title');
      const form = document.createElement('form');
      form.method = 'dialog';
      const h = document.createElement('h2'); h.id = 'mv2-pay-title'; h.textContent = 'Como você quer pagar?';
      form.appendChild(h);
      form.appendChild(payOption('pix', 'Pix à vista', pix ? `${pix}${each}` : '', CFG.pixPercent > 0 ? `${CFG.pixPercent}% de desconto · aprovação na hora` : 'Aprovação na hora', 'mv2-pay__opt--pix'));
      form.appendChild(payOption('card', 'Cartão de crédito', parcel ? `Em até ${parcel}${each}` : (card ? `${card}${each}` : ''), parcel && card ? `Total ${card}${each}` : ''));
      if (others > 0) {
        const p = document.createElement('p'); p.className = 'mv2-pay__aviso';
        p.appendChild(document.createTextNode(`Você já tem ${others} ${others === 1 ? 'outro item' : 'outros itens'} no carrinho. ${others === 1 ? 'Ele vai junto' : 'Eles vão junto'} no pagamento. `));
        const rv = document.createElement('button'); rv.type = 'submit'; rv.value = 'cart'; rv.className = 'mv2-pay__link'; rv.textContent = 'Revisar o carrinho';
        p.appendChild(rv); form.appendChild(p);
      }
      const x = document.createElement('button'); x.type = 'submit'; x.value = 'fechar'; x.className = 'mv2-pay__x'; x.setAttribute('aria-label', 'Fechar'); x.textContent = '×';
      form.appendChild(x);
      dlg.appendChild(form);
      dlg.addEventListener('click', (ev) => { if (ev.target === dlg) dlg.close('fechar'); });
      dlg.addEventListener('close', () => {
        const v = dlg.returnValue;
        dlg.remove();
        resolve(v === 'pix' || v === 'card' || v === 'cart' ? v : null);
      }, { once: true });
      document.body.appendChild(dlg);
      dlg.showModal();
      const first = qs('.mv2-pay__opt', dlg); if (first) first.focus();
    });
  }
  async function checkoutWithProduct(id, quantity, selectionIsCurrent = () => true) {
    if (buyingNow) return;
    buyingNow = true;
    let added = false;
    try {
      if (!selectionIsCurrent()) throw new Error('A seleção mudou. Confira a variante e a quantidade e tente novamente.');
      const metodo = await choosePayment(quantity, await otherCartUnits(id));
      if (!metodo) { buyingNow = false; return 'cancelado'; }
      if (!selectionIsCurrent()) throw new Error('A seleção mudou. Confira a variante e a quantidade e tente novamente.');
      await cartAdd([{ id, quantity }], 'buy_now');
      added = true;
      if (!selectionIsCurrent()) throw new Error('A seleção mudou. Confira a variante e a quantidade no carrinho.');
      publish('mn_buy_now', { variant: id, metodo });
      if (metodo === 'pix') {
        // Pix: o botão verde da Scala (checkout só com Pix, desconto aplicado lá) só existe na página do carrinho;
        // o carrinho abre e aciona esse botão uma vez (initCartPayIntent). Sem ele, o cliente fica no carrinho com as duas formas.
        const destino = new URL(CFG.cartUrl, location.origin);
        destino.searchParams.set('mn_pagar', 'pix');
        window.location.href = destino.pathname + destino.search;
        return;
      }
      if (metodo === 'card') { window.location.href = CFG.checkoutUrl || '/checkout'; return; }
      window.location.href = CFG.cartUrl;
      return;
    } catch (error) {
      if (added || error.cartMutationUncertain) {
        // A linha já existe: revisar o carrinho evita que outra tentativa a duplique.
        toast(added ? 'Produto adicionado. Confira o CEP no carrinho para continuar.' : 'Confira o carrinho antes de continuar.');
        window.location.href = CFG.cartUrl;
        return;
      }
      buyingNow = false;
      throw error;
    }
  }
  function initPdp() {
    if (!document.body.classList.contains('template-product')) return;
    let stickyAddBusy = false;
    let pdpVariantReady = true;
    let refreshStickyControls = () => { qsa('[data-mv2-sticky-add]').forEach((button) => { button.disabled = false; }); };
    let refreshPdpBuyNow = () => {};
    if (typeof window.addEventListener === 'function') window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      buyingNow = false;
      if (pdpVariantReady) qsa('[data-mv2-buynow]').forEach((button) => { button.disabled = false; });
      refreshStickyControls();
      refreshPdpBuyNow();
    });
    qsa('[data-mv2-buynow]').forEach((btn) => btn.addEventListener('click', async () => {
      if (buyingNow || stickyAddBusy) return;
      if (!pdpVariantReady) { toast('Aguarde a atualização da variante.'); return; }
      // Ofertas por CEP: a página abre no menor preço; antes de pagar o cliente informa o CEP (o preço fica ou sobe).
      const ofertas = qs('[data-mn-ofertas][data-mn-ready]');
      if (ofertas && !ofertas.dataset.mnOfertasOk) {
        const cepInput = qs('[data-mn-ofertas-cep]', ofertas);
        ofertas.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
        if (cepInput) { cepInput.setAttribute('aria-invalid', 'true'); try { cepInput.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
        toast('Informe seu CEP para ver o preço e o frete da sua região.');
        return;
      }
      const id = currentVariantId(); if (!id) { toast('Selecione uma variante disponível.'); return; }
      const quantity = currentQty();
      qsa('[data-mv2-buynow]').forEach((button) => { button.disabled = true; });
      try {
        const r = await checkoutWithProduct(id, quantity, () => pdpVariantReady && currentVariantId() === id && currentQty() === quantity);
        if (r === 'cancelado') { if (pdpVariantReady) qsa('[data-mv2-buynow]').forEach((button) => { button.disabled = false; }); refreshPdpBuyNow(); }
      }
      catch (e) { toast(e.message); if (pdpVariantReady) qsa('[data-mv2-buynow]').forEach((button) => { button.disabled = false; }); refreshPdpBuyNow(); }
    }));
    qsa('[data-mv2-sticky-add]').forEach((btn) => btn.addEventListener('click', async () => {
      if (!pdpVariantReady || stickyAddBusy || buyingNow) return;
      const id = currentVariantId(); if (!id) { toast('Selecione uma variante disponível.'); return; }
      stickyAddBusy = true; btn.disabled = true;
      refreshPdpBuyNow();
      try { await cartAdd([{ id, quantity: currentQty() }], 'sticky'); toast('Adicionado ao carrinho.', 'Ver carrinho', CFG.cartUrl); }
      catch (e) { toast(e.message); } finally { stickyAddBusy = false; refreshStickyControls(); refreshPdpBuyNow(); }
    }));
    // Pix da barra fixa: copia o valor da oferta renderizada (fonte única); só com desconto configurado e linha Pix visível.
    function syncStickyPix(stickyRoot, offerRoot) {
      const stickyPix = stickyRoot ? qs('[data-mv2-sticky-pix]', stickyRoot) : null;
      if (!stickyPix) return;
      const enabled = offerRoot && !offerRoot.hidden && offerRoot.dataset?.mnPixEnabled === 'true';
      const pixRow = enabled ? qs('[data-mn-pix-row]', offerRoot) : null;
      const pixValue = pixRow && !pixRow.hidden ? qs('[data-mn-pix-price]', pixRow)?.textContent?.trim() : '';
      if (pixValue) { stickyPix.textContent = `${pixValue} no Pix`; stickyPix.hidden = false; }
      else { stickyPix.textContent = ''; stickyPix.hidden = true; }
    }
    const sticky = qs('[data-mv2-sticky]'); const anchor = qs('[data-mv2-pdp-anchor]');
    syncStickyPix(sticky, qs('maknorte-product-offer'));
    if (sticky && anchor) {
      const nativeSticky = qs('sticky-add-to-cart');
      const hasIntersectionObserver = typeof window.IntersectionObserver === 'function';
      let stickyAnchorVisible = true;
      let stickyVariantReady = sticky.dataset.variantAvailable === 'true';
      pdpVariantReady = stickyVariantReady;
      let stickyVariantGeneration = 0;
      const stickyButtons = qsa('[data-mv2-sticky-add], [data-mv2-buynow]', sticky);
      const applyStickyState = () => {
        sticky.hidden = !hasIntersectionObserver || !stickyVariantReady || stickyAnchorVisible;
        stickyButtons.forEach((button) => {
          button.disabled = !stickyVariantReady || buyingNow || stickyAddBusy;
        });
      };
      refreshStickyControls = applyStickyState;
      refreshPdpBuyNow = () => {
        qsa('[data-mv2-buynow]').forEach((button) => { button.disabled = !pdpVariantReady || buyingNow || stickyAddBusy; });
      };
      const setStickyVariantReady = (ready) => {
        stickyVariantReady = ready;
        pdpVariantReady = ready;
        applyStickyState();
        refreshPdpBuyNow();
      };
      const purchaseAnchor = () => productForm()?.querySelector('[type="submit"]') || qs('[data-mv2-pdp-anchor]');
      let observedAnchor = purchaseAnchor();
      let io;
      const syncStickyGeometry = () => {
        const liveAnchor = purchaseAnchor();
        if (!liveAnchor) { stickyAnchorVisible = true; applyStickyState(); return; }
        if (liveAnchor !== observedAnchor && io) { io.unobserve(observedAnchor); io.observe(liveAnchor); observedAnchor = liveAnchor; }
        stickyAnchorVisible = liveAnchor.getBoundingClientRect().bottom > 0;
        applyStickyState();
      };
      syncStickyGeometry();
      refreshPdpBuyNow();
      if (hasIntersectionObserver) {
        io = new IntersectionObserver(() => syncStickyGeometry(), { threshold: 0 });
        io.observe(observedAnchor);
        if (nativeSticky) nativeSticky.dataset.mv2Replaced = 'true';
      }

      const handlePdpProductSelect = (event) => {
        if (event.target instanceof Element && event.target.closest('product-card')) return;
        if (String(event.product?.id || '') !== String(sticky.dataset.productId || '')) return;
        const generation = ++stickyVariantGeneration;
        setStickyVariantReady(false);
        if (!event.promise || typeof event.promise.then !== 'function') return;
        Promise.resolve(event.promise).then(({ detail }) => {
          if (generation !== stickyVariantGeneration) return;
          const variant = detail?.resource;
          if (!detail?.html || !variant || variant.available !== true) return;
          if (detail.productId && !detail.newProduct && String(detail.productId) !== String(sticky.dataset.productId)) return;

          const visibleText = (element) => {
            if (!element) return '';
            const hiddenText = element.querySelector?.('.visually-hidden')?.textContent || '';
            return element.textContent?.replace(hiddenText, '').trim() || '';
          };
          const priceSource = qs('[data-testid="sticky-price-display"] .price, [data-testid="sticky-price-display"] .price-item__group.price', detail.html);
          const priceText = visibleText(priceSource);
          const variantId = variant.id || event.detail?.variantId;
          if (!priceText || !variantId) return;

          const price = qs('[data-mv2-sticky-price]', sticky);
          const title = qs('[data-mv2-sticky-title]', sticky);
          const variantTitle = qs('[data-mv2-sticky-variant]', sticky);
          const imageBox = qs('[data-mv2-sticky-image]', sticky);
          const image = qs('img', imageBox);
          const parcel = qs('[data-mv2-sticky-parcel]', sticky);
          const offer = qs('maknorte-product-offer', detail.html);
          const titleSource = qs('[data-testid="sticky-product-title"]', detail.html);
          const variantTitleSource = qs('[data-testid="sticky-variant-title"]', detail.html);
          const installmentSource = offer && !offer.hidden ? qs('[data-mn-installments]', offer) : null;
          const installmentPrice = installmentSource && !installmentSource.hidden ? qs('[data-mn-installment-price]', installmentSource) : null;
          const imageSrc = variant.featured_media?.preview_image?.src || variant.featured_image?.src || variant.featured_image?.url || (typeof variant.featured_image === 'string' ? variant.featured_image : '');

          if (price) price.textContent = priceText;
          syncStickyPix(sticky, offer);
          if (title && titleSource?.textContent?.trim()) title.textContent = titleSource.textContent.trim();
          if (variantTitle) {
            const variantText = variantTitleSource?.textContent?.trim() || '';
            variantTitle.textContent = variantText;
            variantTitle.hidden = !variantText || variantText === 'Default Title';
          }
          if (parcel) {
            const parcelText = installmentPrice?.textContent?.trim() || '';
            parcel.textContent = parcelText;
            parcel.hidden = !parcelText;
          }
          if (imageBox) imageBox.hidden = !imageSrc;
          if (image) {
            if (imageSrc) { image.src = imageSrc; image.removeAttribute('srcset'); }
            else { image.removeAttribute('src'); image.removeAttribute('srcset'); }
          }
          sticky.dataset.currentVariantId = String(variantId);
          if (detail.productId) sticky.dataset.productId = String(detail.productId);
          setStickyVariantReady(true);
          if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(syncStickyGeometry);
          else syncStickyGeometry();
        }).catch((error) => {
          if (generation !== stickyVariantGeneration) return;
          setStickyVariantReady(false);
          if (error?.name !== 'AbortError') console.warn('[mn-v2-sticky] Variant update failed:', error);
        });
      };
      document.addEventListener('shopify:product:select', handlePdpProductSelect);
      // Ofertas por CEP trocam a variante pelo seletor escondido; a barra fixa copia o que a oferta principal já mostra
      // (preço, Pix, parcelas) e o nome da opção, para não ficar com o preço da outra região.
      const offerRoot = qs('maknorte-product-offer');
      const syncStickyFromOffer = () => {
        const id = currentVariantId();
        if (!id || !offerRoot || offerRoot.hidden) return;
        const ofertasJson = qs('[data-mn-ofertas-json]');
        let nome = '';
        try { const o = ofertasJson && JSON.parse(ofertasJson.textContent).offers.find((x) => String(x.id) === String(id)); nome = o ? String(o.name || '') : ''; } catch (e) { nome = ''; }
        if (!nome) return;                                   // só produtos com ofertas por CEP
        const setT = (el, v) => { if (el && el.textContent !== v) el.textContent = v; };
        sticky.dataset.currentVariantId = String(id);
        setT(qs('[data-mv2-sticky-price]', sticky), (qs('[data-mn-product-price]', offerRoot)?.textContent || '').trim());
        const vt = qs('[data-mv2-sticky-variant]', sticky);
        if (vt) { setT(vt, nome); vt.hidden = false; }
        const parcel = qs('[data-mv2-sticky-parcel]', sticky);
        const inst = qs('[data-mn-installments]', offerRoot);
        const instTxt = inst && !inst.hidden ? (qs('[data-mn-installment-price]', inst)?.textContent || '').trim() : '';
        if (parcel) { setT(parcel, instTxt); parcel.hidden = !instTxt; }
        syncStickyPix(sticky, offerRoot);
      };
      if (offerRoot && typeof MutationObserver === 'function') {
        new MutationObserver(() => requestAnimationFrame(syncStickyFromOffer)).observe(offerRoot, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
      }
      document.addEventListener('variant:update', () => requestAnimationFrame(syncStickyFromOffer));
      syncStickyFromOffer();
    }
    // Acordeão: um painel por vez, primeiro aberto por padrão.
    const acc = qs('.product-details .accordion') || qs('.product-details accordion-custom')?.parentElement;
    if (acc) {
      const details = qsa('details', acc).filter((d) => !d.parentElement.closest('details'));
      const openFirst = () => { if (details.length && !details.some((d) => d.open)) details[0].open = true; };
      openFirst(); setTimeout(openFirst, 400); window.addEventListener('load', () => setTimeout(openFirst, 200));
      details.forEach((d) => d.addEventListener('toggle', () => { if (d.open) details.forEach((o) => { if (o !== d && o.open) o.open = false; }); }));
    }
  }


  /* ---------- Frete real: carrinho atual no carrinho; cartCreate descartável na PDP. ---------- */
  const SHIPPING_FALLBACK = 'Não conseguimos obter as opções de entrega agora. Confira a disponibilidade no checkout ou fale com a MakNorte.';
  const SHIPPING_TEMPORARILY_UNAVAILABLE = 'As opções de entrega estão temporariamente indisponíveis. Tente novamente em alguns instantes ou confira no checkout.';
  function temporaryShippingError() {
    const error = new Error(SHIPPING_TEMPORARILY_UNAVAILABLE);
    error.code = 'shipping_temporarily_unavailable';
    return error;
  }
  const STOREFRONT_SHIPPING_QUERY = `mutation MakNorteShippingQuote($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        totalQuantity
        lines(first: 2) {
          nodes {
            quantity
            merchandise { ... on ProductVariant { id } }
          }
        }
        ...MakNorteShippingGroups @defer
      }
      userErrors { field message }
      warnings { code message }
    }
  }
  fragment MakNorteShippingGroups on Cart {
    deliveryGroups(first: 10, withCarrierRates: true) {
      nodes {
        cartLines(first: 2) {
          nodes {
            quantity
            merchandise { ... on ProductVariant { id } }
          }
        }
        deliveryOptions {
          handle
          title
          description
          deliveryMethodType
          estimatedCost { amount currencyCode }
        }
      }
    }
  }`;
  const UF_RANGES = [[1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'], [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'], [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']];
  function ufFromCep(digits) { const n = parseInt(digits.slice(0, 5), 10); const r = UF_RANGES.find(([a, b]) => n >= a && n <= b); return r ? r[2] : ''; }
  async function lookupUf(digits) {
    return { uf: ufFromCep(digits), city: '' };
  }
  async function quoteCartShipping(digits) {
    const { uf, city } = await lookupUf(digits);
    if (!uf) throw new Error('CEP não reconhecido. Confira os 8 dígitos.');
    const zip = `${digits.slice(0, 5)}-${digits.slice(5)}`;
    const q = `shipping_address[zip]=${encodeURIComponent(zip)}&shipping_address[country]=Brazil&shipping_address[province]=${encodeURIComponent(uf)}`;
    const controller = new AbortController();
    const timeoutError = () => new Error('A consulta demorou demais. Tente de novo ou confira as opções no checkout.');
    const checkDeadline = () => { if (controller.signal.aborted) throw timeoutError(); };
    let timer;
    const poll = async () => {
      const prep = await fetch(`/cart/prepare_shipping_rates.json?${q}`, { method: 'POST', body: '', signal: controller.signal });
      checkDeadline();
      if (!prep.ok) throw new Error(SHIPPING_FALLBACK);
      for (let i = 0; i < 12; i += 1) {
        await new Promise((resolve) => setTimeout(resolve, 1200));
        checkDeadline();
        const res = await fetch(`/cart/async_shipping_rates.json?${q}`, { headers: { Accept: 'application/json' }, signal: controller.signal });
        checkDeadline();
        if (!res.ok) throw new Error(SHIPPING_FALLBACK);
        const txt = await res.text();
        checkDeadline();
        if (!txt || txt === 'null') continue;
        let data; try { data = JSON.parse(txt); } catch (e) { continue; }
        if (data && data.error) throw new Error(Array.isArray(data.error) ? data.error[0] : String(data.error));
        if (data && Array.isArray(data.shipping_rates)) return { rates: data.shipping_rates, uf, city, zip };
      }
      throw timeoutError();
    };
    try {
      return await Promise.race([
        poll(),
        new Promise((_resolve, reject) => {
          timer = setTimeout(() => {
            reject(timeoutError());
            controller.abort();
          }, Math.max(1, Number(CFG.cartShippingQuoteTimeoutMs) || 20000));
        }),
      ]);
    } finally {
      clearTimeout(timer);
      controller.abort();
    }
  }
  function storefrontApiEndpoint() {
    const version = /^\d{4}-\d{2}$/.test(String(CFG.storefrontApiVersion)) ? String(CFG.storefrontApiVersion) : '2026-04';
    const shop = window.Shopify && typeof window.Shopify.shop === 'string' ? window.Shopify.shop.trim().toLowerCase() : '';
    if (/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(shop)) return `https://${shop}/api/${version}/graphql.json`;
    return `${location.origin}/api/${version}/graphql.json`;
  }
  function parseStorefrontPayloads(body, contentType) {
    if (!/multipart\/mixed/i.test(contentType || '')) return [JSON.parse(body)];
    const match = /boundary=(?:"([^"]+)"|([^;\s]+))/i.exec(contentType || '');
    if (!match) throw new Error('Resposta de frete inválida.');
    const boundary = match[1] || match[2];
    return body.split(`--${boundary}`).map((part) => {
      const separator = /\r?\n\r?\n/.exec(part);
      if (!separator) return null;
      const payload = part.slice(separator.index + separator[0].length).trim();
      if (!payload || payload === '--') return null;
      return JSON.parse(payload.replace(/\r?\n--$/, ''));
    }).filter(Boolean);
  }
  function verifiedDeliveryGroup(payloads, variantGid, quantity) {
    const groups = [];
    let createdCart = null;
    const addConnection = (connection) => {
      if (!connection) return;
      if (Array.isArray(connection.nodes)) groups.push(...connection.nodes);
      else if (Array.isArray(connection.edges)) groups.push(...connection.edges.map((edge) => edge && edge.node).filter(Boolean));
    };
    payloads.forEach((payload) => {
      if (Array.isArray(payload.errors) && payload.errors.length) throw temporaryShippingError();
      const cartCreate = payload.data && payload.data.cartCreate;
      if (cartCreate) {
        if (Array.isArray(cartCreate.userErrors) && cartCreate.userErrors.length) throw new Error('Cotação recusada pela Storefront API.');
        if (Array.isArray(cartCreate.warnings) && cartCreate.warnings.length) throw new Error('A Storefront API ajustou a cotação solicitada.');
        createdCart = cartCreate.cart;
        addConnection(cartCreate.cart && cartCreate.cart.deliveryGroups);
      }
      (payload.incremental || []).forEach((part) => {
        if (Array.isArray(part && part.errors) && part.errors.length) throw temporaryShippingError();
        addConnection(part && part.data && part.data.deliveryGroups);
      });
    });
    const lines = createdCart && createdCart.lines && createdCart.lines.nodes;
    const line = Array.isArray(lines) && lines.length === 1 ? lines[0] : null;
    if (!createdCart || createdCart.totalQuantity !== quantity || !line || line.quantity !== quantity || !line.merchandise || line.merchandise.id !== variantGid) {
      throw new Error('A Storefront API não preservou o item solicitado.');
    }
    if (groups.length !== 1) throw new Error('A cotação foi dividida em grupos de entrega.');
    const groupLines = groups[0].cartLines && groups[0].cartLines.nodes;
    const groupLine = Array.isArray(groupLines) && groupLines.length === 1 ? groupLines[0] : null;
    if (!groupLine || groupLine.quantity !== quantity || !groupLine.merchandise || groupLine.merchandise.id !== variantGid) {
      throw new Error('O grupo de entrega não corresponde ao item solicitado.');
    }
    return groups[0];
  }
  async function quoteProductShipping(digits, variantId, quantity) {
    const cleanCep = String(digits || '').replace(/\D/g, '');
    const cleanVariant = String(variantId || '');
    const cleanQuantity = Number(quantity);
    if (!/^\d{8}$/.test(cleanCep)) throw new Error('Informe um CEP com 8 dígitos.');
    if (!/^\d+$/.test(cleanVariant) || cleanVariant === '0') throw new Error('Selecione uma variante disponível.');
    if (!Number.isInteger(cleanQuantity) || cleanQuantity < 1) throw new Error('Selecione uma quantidade válida.');
    const zip = `${cleanCep.slice(0, 5)}-${cleanCep.slice(5)}`;
    const uf = ufFromCep(cleanCep);
    if (!uf) throw new Error('CEP não reconhecido. Confira os 8 dígitos.');
    const variantGid = `gid://shopify/ProductVariant/${cleanVariant}`;
    const controller = new AbortController();
    const timeoutMs = Math.max(1, Number(CFG.shippingQuoteTimeoutMs) || 5000);
    let timeout;
    try {
      const request = (async () => {
        const response = await fetch(storefrontApiEndpoint(), {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json', Accept: 'multipart/mixed; deferSpec=20220824, application/json' },
          body: JSON.stringify({
            query: STOREFRONT_SHIPPING_QUERY,
            variables: {
              input: {
                lines: [{ merchandiseId: variantGid, quantity: cleanQuantity }],
                buyerIdentity: {
                  countryCode: 'BR',
                  deliveryAddressPreferences: [{
                    deliveryAddress: { country: 'Brazil', province: uf, zip },
                  }],
                },
              },
            },
          }),
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`Storefront API HTTP ${response.status}`);
        const payloads = parseStorefrontPayloads(await response.text(), response.headers.get('content-type') || '');
        const group = verifiedDeliveryGroup(payloads, variantGid, cleanQuantity);
        const rates = (group.deliveryOptions || []).map((option) => ({
          name: option.title || 'Entrega',
          description: option.description || '',
          price: option.estimatedCost && option.estimatedCost.amount,
          currency: option.estimatedCost && option.estimatedCost.currencyCode,
        })).filter((rate) => String(rate.price == null ? '' : rate.price).trim() !== '' && Number.isFinite(Number(rate.price)) && Number(rate.price) >= 0 && rate.currency === 'BRL');
        return { rates, zip, uf, city: '', quoteScope: 'product' };
      })();
      return await Promise.race([
        request,
        new Promise((_resolve, reject) => {
          timeout = setTimeout(() => {
            controller.abort();
            reject(new Error('shipping_quote_timeout'));
          }, timeoutMs);
        }),
      ]);
    } catch (error) {
      if (error && error.code === 'shipping_temporarily_unavailable') throw error;
      throw new Error(SHIPPING_FALLBACK);
    } finally {
      clearTimeout(timeout);
      controller.abort();
    }
  }
  function fmtDate(iso) { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); return m ? `${m[3]}/${m[2]}` : ''; }
  function renderRates(list, result) {
    list.innerHTML = '';
    if (!result.rates.length) { const li = document.createElement('li'); li.className = 'mv2-ship__empty'; li.textContent = result.quoteScope === 'product' ? 'Nenhuma opção de entrega para este CEP com este produto e quantidade. Fale com o consultor.' : 'Nenhuma opção de entrega para este CEP com os itens do carrinho. Fale com o consultor.'; list.appendChild(li); return; }
    [...result.rates].sort((a, b) => parseFloat(a.price) - parseFloat(b.price)).forEach((r) => {
      const li = document.createElement('li'); li.className = 'mv2-ship__item';
      const name = document.createElement('span'); name.className = 'mv2-ship__name'; name.textContent = r.name === 'Local Delivery' ? 'Entrega local (MakNorte)' : r.name;
      const meta = document.createElement('span'); meta.className = 'mv2-ship__meta';
      const end = r.delivery_range && r.delivery_range[1] ? fmtDate(r.delivery_range[1]) : '';
      const days = Array.isArray(r.delivery_days) && r.delivery_days.length ? r.delivery_days[r.delivery_days.length - 1] : null;
      meta.textContent = r.description || (end ? `Entrega estimada até ${end}${days ? ` (${days} dias)` : ''}` : (r.name === 'Local Delivery' ? 'Prazo combinado com a entrega local' : 'Prazo informado no checkout'));
      const price = document.createElement('strong'); price.className = 'mv2-ship__price'; const cents = Math.round(parseFloat(r.price) * 100); price.textContent = cents === 0 ? 'Grátis' : money(cents);
      const text = document.createElement('span'); text.className = 'mv2-ship__text'; text.append(name, meta);
      li.append(text, price); list.appendChild(li);
    });
  }
  function bindCepInput(input) { input.addEventListener('input', () => { const d = input.value.replace(/\D/g, '').slice(0, 8); input.value = d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d; }); }
  function savedCep() {
    const shared = window.MnDelivery;
    if (shared && typeof shared.getCep === 'function') return shared.getCep();
    if (sessionCep) return sessionCep;
    if (refreshPreferences(false) !== 'allowed') return '';
    const storage = browserStorage();
    try {
      const value = storage && storage.getItem(CEP_KEY);
      if (!value || !/^\d{5}-\d{3}$/.test(value)) return '';
      const savedAtValue = storage.getItem(CEP_SAVED_AT_KEY);
      if (!savedAtValue) {
        storage.setItem(CEP_SAVED_AT_KEY, String(Date.now()));
        return value;
      }
      const savedAt = Number(savedAtValue);
      if (!Number.isFinite(savedAt) || savedAt <= 0 || Date.now() - savedAt > CEP_RETENTION_MS || savedAt > Date.now()) {
        clearPersistedCep();
        return '';
      }
      return value;
    } catch (e) { return ''; }
  }
  function saveCep(value, source = 'v2') {
    const shared = window.MnDelivery;
    if (shared && typeof shared.setCep === 'function') return shared.setCep(value, source);
    const digits = String(value || '').replace(/\D/g, '');
    if (!/^\d{8}$/.test(digits)) return { ok: false, error: 'invalid_format' };
    const permission = refreshPreferences(false);
    sessionCep = `${digits.slice(0, 5)}-${digits.slice(5)}`;
    if (permission !== 'allowed') return { ok: true, digits, formatted: sessionCep, verification: 'format_only', source };
    const storage = browserStorage();
    try {
      if (storage) {
        storage.setItem(CEP_SAVED_AT_KEY, String(Date.now()));
        storage.setItem(CEP_KEY, sessionCep);
      }
    } catch (e) { clearPersistedCep(); }
    return { ok: true, digits, formatted: sessionCep, verification: 'format_only', source };
  }
  function bindSharedCep(input, invalidate) {
    if (typeof window.addEventListener !== 'function') return;
    window.addEventListener('maknorte:cep:changed', (event) => {
      if (event.detail && event.detail.source === 'consent_ready' && input.value.trim()) return;
      const next = savedCep();
      if (input.value !== next) input.value = next;
      invalidate();
    });
  }
  function checkoutCep() {
    const input = qs('[data-mv2-cep] input, [data-mv2-ship-cep], [data-mn-cep-input]');
    return (input && String(input.value || '').trim()) || savedCep();
  }
  async function prepareCheckout() {
    const raw = checkoutCep();
    if (!raw) return;
    const digits = raw.replace(/\D/g, '');
    const province = /^\d{8}$/.test(digits) ? ufFromCep(digits) : '';
    if (!province) throw new Error('Confira o CEP com 8 dígitos antes de continuar.');
    const cartRoute = new URL(CFG.cartUrl, location.origin);
    if (cartRoute.origin !== location.origin || !/\/cart\/?$/.test(cartRoute.pathname)) {
      throw new Error('Não conseguimos confirmar o CEP. Recarregue a página e tente novamente.');
    }
    const saved = saveCep(digits, 'checkout');
    if (!saved || !saved.ok) throw new Error('Confira o CEP antes de continuar.');
    const bridge = window.MNCheckoutAddress;
    let result;
    try {
      if (!bridge || typeof bridge.prepare !== 'function') throw new Error('address_bridge_unavailable');
      result = await bridge.prepare(digits);
      if (!result || !result.ok) throw new Error('address_preparation_failed');
    } catch (error) {
      if (new URLSearchParams(location.search).get('mn_checkout_debug') === '1' && typeof console !== 'undefined') {
        console.warn('MakNorte CEP diagnostic', JSON.stringify({
          code: result && result.code || 'module_unavailable',
          diagnostics: result && result.errors,
          cartReturned: result && result.cartReturned,
          opaqueIdSame: result && result.opaqueIdSame,
          preserved: result && result.preserved,
        }));
      }
      if (result && (result.code === 'reload_required' || result.mutated === true)) {
        throw new Error('Não conseguimos confirmar o CEP. Recarregue a página para conferir o endereço antes de continuar.');
      }
      throw new Error('Não conseguimos confirmar o CEP para o checkout. Tente novamente ou confira o CEP informado.');
    }
    if (checkoutCep().replace(/\D/g, '') !== digits) {
      throw new Error('O CEP mudou durante a confirmação. Confira o novo CEP e tente novamente.');
    }
    return result;
  }
  async function runQuote(form, msg, list, digits, note, quote = quoteCartShipping, isCurrent = () => true) {
    msg.hidden = false; msg.classList.remove('mv2-cep__msg--error'); msg.textContent = 'Consultando transportadoras…'; list.innerHTML = '';
    if (note) note.hidden = true;
    const btn = qs('button[type="submit"]', form); if (btn) btn.disabled = true;
    try {
      const result = await quote();
      if (!isCurrent()) return;
      msg.textContent = `Opções para ${result.zip}${result.city ? ` · ${result.city}/${result.uf}` : ` · ${result.uf}`}:`;
      renderRates(list, result); if (note) note.hidden = false;
      publish('mn_shipping_quote', { uf: result.uf, options: result.rates.length, cheapest: result.rates.length ? Math.min(...result.rates.map((r) => parseFloat(r.price))) : null });
    } catch (e) { if (isCurrent()) { msg.classList.add('mv2-cep__msg--error'); msg.textContent = e.message; } }
    finally { if (btn && isCurrent()) btn.disabled = false; }
  }
  function initCartShipping() {
    const root = qs('[data-mv2-ship]'); if (!root) return;
    const form = qs('[data-mv2-ship-form]', root); const input = qs('[data-mv2-ship-cep]', root); const msg = qs('[data-mv2-ship-msg]', root); const list = qs('[data-mv2-ship-list]', root);
    if (!form || !input) return;
    bindCepInput(input);
    const fromUrl = (new URLSearchParams(location.search).get('cep') || '').replace(/\D/g, '').slice(0, 8);
    const initial = fromUrl.length === 8 ? `${fromUrl.slice(0, 5)}-${fromUrl.slice(5)}` : savedCep();
    if (initial) input.value = initial;
    const button = qs('button[type="submit"]', form);
    let latestRequest = 0;
    let pendingCartUpdates = 0;
    const invalidate = () => {
      latestRequest += 1;
      list.innerHTML = '';
      msg.hidden = true;
      if (button) button.disabled = pendingCartUpdates > 0;
    };
    input.addEventListener('input', invalidate);
    document.addEventListener('quantity-selector:update', invalidate);
    bindSharedCep(input, invalidate);
    document.addEventListener('shopify:cart:lines-update', (event) => {
      invalidate();
      if (!event.promise || typeof event.promise.then !== 'function') return;
      pendingCartUpdates += 1;
      if (button) button.disabled = true;
      const settled = () => { pendingCartUpdates -= 1; invalidate(); };
      Promise.resolve(event.promise).then(settled, settled);
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (pendingCartUpdates) {
        msg.hidden = false;
        msg.textContent = 'Aguarde a atualização do carrinho para calcular o frete.';
        return;
      }
      const d = input.value.replace(/\D/g, '');
      if (d.length !== 8) { msg.hidden = false; msg.classList.add('mv2-cep__msg--error'); msg.textContent = 'Informe um CEP com 8 dígitos.'; return; }
      saveCep(input.value);
      const requestId = ++latestRequest;
      runQuote(form, msg, list, d, null, () => quoteCartShipping(d),
        () => requestId === latestRequest && !pendingCartUpdates && input.value.replace(/\D/g, '') === d);
    });
    // CEP já informado no site (topo, produto): calcula o frete sozinho ao abrir o carrinho.
    // Isso mostra as opções na hora e grava o CEP no carrinho, que chega preenchido no checkout.
    // Só o CEP que o próprio cliente salvou (não o que vem na URL) dispara o cálculo automático.
    let autoQuoted = false;
    const autoQuote = () => {
      if (autoQuoted || fromUrl.length === 8 || pendingCartUpdates) return;
      if (input.value.replace(/\D/g, '').length !== 8) return;
      autoQuoted = true;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else if (typeof form.dispatchEvent === 'function' && typeof Event === 'function') form.dispatchEvent(new Event('submit', { cancelable: true }));
    };
    if (typeof setTimeout === 'function') {
      setTimeout(autoQuote, 400);
      if (typeof window.addEventListener === 'function') window.addEventListener('maknorte:cep:changed', () => setTimeout(autoQuote, 50));
    }
  }
  function initPdpShipping() {
    const box = qs('[data-mv2-cep]'); if (!box || !document.body.classList.contains('template-product')) return;
    const toggle = qs('[data-mv2-cep-toggle]', box); const form = qs('form', box); const input = qs('input', box); const msg = qs('[data-mv2-cep-msg]', box); const list = qs('[data-mv2-ship-list]', box); const note = qs('[data-mv2-ship-note]', box);
    if (!form || !input) return;
    if (toggle) toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); form.hidden = !open; if (open) input.focus(); });
    bindCepInput(input);
    const saved = savedCep(); if (saved) input.value = saved;
    let latestRequest = 0;
    const invalidate = () => { latestRequest += 1; list.innerHTML = ''; msg.hidden = true; if (note) note.hidden = true; const button = qs('button[type="submit"]', form); if (button) button.disabled = false; };
    input.addEventListener('input', invalidate);
    document.addEventListener('quantity-selector:update', invalidate);
    bindSharedCep(input, invalidate);
    document.addEventListener('change', (event) => { if (event.target && (event.target.name === 'id' || event.target.name === 'quantity')) invalidate(); });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const d = input.value.replace(/\D/g, '');
      if (d.length !== 8) { msg.hidden = false; msg.classList.add('mv2-cep__msg--error'); msg.textContent = 'Informe um CEP com 8 dígitos.'; return; }
      saveCep(input.value, 'pdp'); publish('mn_cep_saved', { format_valid: true });
      const variant = currentVariantId(); if (!variant) { msg.hidden = false; msg.classList.add('mv2-cep__msg--error'); msg.textContent = 'Selecione uma variante disponível.'; return; }
      const quantity = currentQty();
      const requestId = ++latestRequest;
      if (note) note.textContent = 'Cotação feita separadamente para este produto e quantidade, sem alterar seu carrinho; o valor final é confirmado no checkout.';
      await runQuote(
        form,
        msg,
        list,
        d,
        note,
        () => quoteProductShipping(d, variant, quantity),
        () => requestId === latestRequest && currentVariantId() === variant && currentQty() === quantity && input.value.replace(/\D/g, '') === d,
      );
    });
  }

  /* ---------- Ofertas por CEP nos cards: com CEP informado, o card mostra o preço da região do cliente ---------- */
  function cepDigits() {
    try { return String((window.MnDelivery && typeof window.MnDelivery.getCep === 'function' && window.MnDelivery.getCep()) || '').replace(/\D/g, ''); }
    catch (e) { return ''; }
  }
  function setText(el, value) { if (el && el.textContent !== value) el.textContent = value; }
  function regionalizeCard(box, cep) {
    let offers;
    try { offers = JSON.parse(box.dataset.mnOfOffers || '[]'); } catch (e) { return; }
    if (!Array.isArray(offers) || offers.length < 2) return;
    if (!box.dataset.mnOfOriginal) {
      const p0 = qs('.price', box); const x0 = qs('.mn-pix-price strong', box);
      box.dataset.mnOfOriginal = JSON.stringify({ price: p0 ? p0.textContent : '', pix: x0 ? x0.textContent : '' });
    }
    const priceEl = qs('.price', box); const pixEl = qs('.mn-pix-price strong', box);
    let note = qs('[data-mn-of-card-note]', box);
    const ok = /^\d{8}$/.test(cep);
    const n = ok ? Number(cep) : 0;
    const ceara = n >= 60000000 && n <= 63999999;
    const isCe = (o) => /cear[aá]/i.test(String(o.name)) && !/exceto/i.test(String(o.name));
    const offer = ok ? offers.find((o) => o && o.available && (ceara ? isCe(o) : /exceto/i.test(String(o.name)))) : null;
    if (!offer || !(Number(offer.price) > 0)) {
      const orig = JSON.parse(box.dataset.mnOfOriginal);
      setText(priceEl, orig.price);
      setText(pixEl, orig.pix);
      if (note) note.remove();
      return;
    }
    const pct = Number(box.dataset.mnOfPix) || 0;
    setText(priceEl, money(offer.price));
    if (pct > 0 && pct < 100) setText(pixEl, money(Math.round(offer.price * (100 - pct) / 100)));
    if (!note) { note = document.createElement('small'); note.setAttribute('data-mn-of-card-note', ''); note.className = 'mn-of-card-note'; note.style.cssText = 'display:block;margin-top:2px;font-size:12px;color:#4b5563'; box.appendChild(note); }
    const chave = `${cep}|${ceara}`;
    if (note.dataset.mnOfKey !== chave) {
      note.dataset.mnOfKey = chave;
      note.textContent = 'Preço para o CEP ';
      const c = document.createElement('span'); c.style.whiteSpace = 'nowrap'; c.textContent = `${cep.slice(0, 5)}-${cep.slice(5)}`;
      note.appendChild(c);
      note.appendChild(document.createTextNode(` (${ceara ? 'Ceará' : 'fora do Ceará'})`));
    }
  }
  function initRegionalCards() {
    const run = () => { const cep = cepDigits(); qsa('[data-mn-of-card]').forEach((box) => regionalizeCard(box, cep)); };
    run();
    window.addEventListener('maknorte:cep:changed', run);
    let pending = false;
    if (typeof MutationObserver === 'function') new MutationObserver((muts) => {
      if (pending || !muts.some((m) => m.addedNodes && m.addedNodes.length && !(m.target.closest && m.target.closest('[data-mn-of-card]')))) return;
      pending = true; requestAnimationFrame(() => { pending = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  /* ---------- Carrinho aberto pela escolha "Pix" do Comprar agora: leva o cliente ao botão verde da Scala ---------- */
  // A Scala só aceita toque real (clique por código é ignorado), então o tema rola até o botão, destaca e explica.
  async function initCartPayIntent() {
    let url;
    try { url = new URL(location.href); } catch (e) { return; }
    if (url.searchParams.get('mn_pagar') !== 'pix') return;
    url.searchParams.delete('mn_pagar');
    try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (e) { /* noop */ }
    const deadline = Date.now() + 6000;
    let button = scalaCheckoutButton();
    while (!button && Date.now() < deadline) { await new Promise((r) => setTimeout(r, 100)); button = scalaCheckoutButton(); }
    const host = button && button.getRootNode && button.getRootNode().host;
    if (!host) { toast('Para pagar no Pix com desconto, use o botão verde do Pix.'); return; }
    host.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
    host.style.outline = '3px solid #087443'; host.style.outlineOffset = '4px'; host.style.borderRadius = '12px';
    setTimeout(() => { host.style.outline = ''; host.style.outlineOffset = ''; }, 6000);
    try { button.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    toast('Toque em "Finalizar compra com Pix" para pagar com desconto.');
  }
  function init() { initSearch(); initKits(); initCards(); initCatalog(); initNav(); initPdp(); initCartShipping(); initPdpShipping(); initRegionalCards(); initCartPayIntent(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MNV2Api = { toast, cartAdd, money, quoteProductShipping, prepareCheckout };
})();
